<template>
  <div class="pa-7">
    <v-layout
    justify-center
    class="mb-3">
      <div id="contact">
        {{ title }}
        <v-icon>
          mdi-message-bulleted
        </v-icon>
      </div>
    </v-layout>
    <v-layout justify-center>
      <div
      v-for="(btn, i) in button"
      :key="i"
      class="pt-5">
        <v-btn
        rounded
        outlined
        :href="btn.href"
        class="mx-1"
        color="primary">
        {{ btn.content }}
        <v-icon class="ml-1">
          {{ btn.icon }}
        </v-icon>
        </v-btn>
      </div>
    </v-layout>
  </div>
</template>

<style>
#contact {
  font-size: 30px;
}
</style>

<script>
export default {
  data () {
    return {
      title: 'お問い合わせ',
      button: [
        {
          content: '電話をかける',
          icon: 'mdi-phone',
          href: 'tel:0886258102'
        },
        {
          content: 'メールを送る',
          icon: 'mdi-email',
          href: 'mailto:info@konniesystem.co.jp'
        }
      ]
    }
  }
}
</script>
